import React, { useEffect } from "react";
import { getCurrencySymbol } from "../../../features/utils/countires";
import CommonDropdownInput from "../../common/inputs/CommonDropdownInput";
import CommonFreeTextInput from "../../common/inputs/CommonFreeTextInput";

const options = {
  type: ["Fixed", "Percentage"],
};

export default function CreateInvoiceServiceFeeSection({ data, setData }) {
  useEffect(() => {
    setData({ ...data, serviceFee: { ...data?.serviceFee, value: "" } });
  }, [data?.serviceFee?.feeMethod]);

  return (
    <div className="flex gap-2 mt-2">
      <div className="flex flex-col gap-1 flex-1">
        <div className="flex gap-2 items-center flex-col lg:flex-row">
          <CommonDropdownInput
            label={`Service fee type`}
            className="lg:!w-[150px]"
            options={options.type}
            value={data?.serviceFee?.feeMethod}
            onChange={(value) => {
              setData({
                ...data,
                serviceFee: { ...data?.serviceFee, feeMethod: value },
              });
            }}
          />
          <CommonFreeTextInput
            label={`Amount (${
              data?.serviceFee?.feeMethod === "Fixed"
                ? getCurrencySymbol("NGN")
                : "%"
            })`}
            value={data?.serviceFee?.value}
            onChange={(value) => {
              const digitsOnly = value.replace(/\D/g, "");
              setData({
                ...data,
                serviceFee: { ...data?.serviceFee, value: digitsOnly },
              });
            }}
          />
        </div>
      </div>
    </div>
  );
}
